import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a513df22cc2500014ee61c7_1783722211270_30623957/jarvondisu/src/app/sign-up-login-screen/components/AuthScreen.tsx");
